import React from "react";
import { Button } from "../../primary";
import PlusIcon from "../../../static/images/plus-icon_white.svg";
import { MultiFileUploadFormBuilder } from "./multiFileUploadFormBuilder";
import styles from './assign.module.scss';

export const MediaList = ({
  media,
  addMedia,
  handleAddMedia,
  handleAddMediaCancel,
  questionId,
  formId,
  questionIndex,
  customFormBuilder,
  setcustomFormBuilder,
  setSectionInfo,
  dropRef,
}) => {
  return (
    <>
      {media?.images?.length < 5 ? (
        <Button classes={{ className: `btn ${styles.btn_customs} ${styles.btn_smalls}` }} type="button" onClick={() => handleAddMedia(questionIndex)}>
          <img src={PlusIcon} alt="edit" />
          Add Media
        </Button>
      ) : (
        <Button classes={{ className: `btn ${styles.btn_custom_disable} ${styles.btn_smalls}` }} type="button" disabled>
          <img src={PlusIcon} alt="edit" />
          Add Media
        </Button>
      )}
      {addMedia?.index === questionIndex && (
        <div className={`dropdown-menu show ${styles.media_align}`} ref={dropRef}>
          <MultiFileUploadFormBuilder
            handleAddMediaCancel={handleAddMediaCancel}
            questionId={questionId}
            formId={formId}
            mediaList={media}
            questionIndex={questionIndex}
            customFormBuilder={customFormBuilder}
            setcustomFormBuilder={setcustomFormBuilder}
            setSectionInfo={setSectionInfo}
          />
        </div>
      )}
    </>
  );
};
